import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";
import "./PaymentPlanWindow.css";
import { useWindowSize } from "../hooks/windowSize";
import Swal from "sweetalert2";

function PaymentPlanWindow({
  onClose,
  selectedSystemName,
  userId,
  userData
}) {
  const [planName, setPlanName] = useState("visitor");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedBillingCycle, setSelectedBillingCycle] = useState("monthly");
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [enrichedPlans, setEnrichedPlans] = useState([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(true);
  const [networkError, setNetworkError] = useState(false); // ✅ ADD THIS
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingPaymentButton, setLoadingPaymentButton] = useState(false);
  



  useEffect(() => {
  if (!userId) {
    console.log('userId payment window:', userId);

  setIsLoadingPlans(false);
  

  Swal.fire({
    icon: "error",
    title: "Session Expired",
    text: "Your session has expired. Please login again.",
    showCancelButton: true,
    confirmButtonText: "Login",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = `https://nktechhub.com/login`;
    }
  });
  ensureSwalOnTop();
  }
  
}, [userId]);




  const createSessionAndRedirect = async () => {
    try {
      const token = localStorage.getItem('token');
      // ✅ 1. Create session
      // const response = await fetch(`https://api.nktechhub.com/api/dcs/simulator/create-session`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({ userData: userData }),
      //   credentials: 'include'
      // });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      // ✅ 2. Parse the response
      // const data = await response.json();
      // const { sessionId } = data;

      // setIsAlertOpen(false);

      // ✅ 3. Show success message
      Swal.fire({
        icon: 'success',
        title: 'Redirecting',
        text: 'Redirecting to Refinery Simulator...',
        timer: 2000,
        showConfirmButton: false,
      });

      // ✅ 4. Redirect to simulator with session ID
      // Use environment variable for flexibility
      const simulatorUrl = `https://refinery.nktechhub.com` || 'http://localhost:3001' || import.meta.env.VITE_REFINERY_SIMULATOR_URL ;
      window.location.href = `${simulatorUrl}?token=${token}`;

    } catch (error) {
      console.error('❌ Error creating session:', error);
      setIsAlertOpen(false);

      // Show error message
      Swal.fire({
        icon: 'error',
        title: 'Redirect Failed',
        text: 'Could not create session. Please try again.',
        confirmButtonText: 'OK'
      });

      // Fallback: Redirect without session (might require login)
      window.location.href = 'https://refinery.nktechhub.com';
    }
  };


  const tokenRedirect = async () => {

    const token = localStorage.getItem('token');
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `https://nktechhub.com/login`;
        }
      });
      return;
    }

    try {
      const response = await fetch(`https://api.nktechhub.com/user/v1/get-data`,{
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`Failed to get user data: ${response.status}`);
      }

      const data = await response.json();

      setIsAlertOpen(false);

      // ✅ 3. Show success message
      Swal.fire({
        icon: 'success',
        title: 'Redirecting',
        text: 'Redirecting to Refinery Simulator...',
        timer: 2000,
        showConfirmButton: false,
      });
      ensureSwalOnTop();

      // ✅ 4. Redirect to simulator with session ID
      // Use environment variable for flexibility
      const simulatorUrl = 'https://refinery.nktechhub.com' || 'http://localhost:3001' || import.meta.env.VITE_REFINERY_SIMULATOR_URL;
      window.location.href = `${simulatorUrl}?token=${token}`;
      return;
      
    } catch (error) {
      console.error('❌ Error creating session:', error);
      setIsAlertOpen(false);

      // Show error message
      Swal.fire({
        icon: 'error',
        title: 'Redirect Failed',
        text: 'Could not create session. Please try again.',
        confirmButtonText: 'OK'
      });
      ensureSwalOnTop();

    }
  };


  // ✅ FIXED CODE
  useEffect(() => {
    if (userData) {
      const fetchPrice = async () => {
        try {
          setIsLoadingPlans(true);
          setNetworkError(false); // Add this state

          const response = await fetch(`https://api.nktechhub.com/api/dcs/payment_plans`);

          if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
          }

          const data = await response.json();

          // Get the plans array from the response
          const dbPlans = data.plans?.rows || data.plans || data || [];

          if (!dbPlans || dbPlans.length === 0) {
            throw new Error('No plans found in database');
          }

          setPaymentPlans(dbPlans);

          // Enrich the static plans with database prices
          const staticPlans = allPlans[selectedSystemName] || defaultPlans;
          const enriched = staticPlans.map(plan => {
            const dbPlan = dbPlans.find(p => p.plan_name === plan.name);
            if (dbPlan) {
              return {
                ...plan,
                price: Number(dbPlan.base_price_monthly) === 0 ? "FREE" : `${dbPlan.base_price_monthly}$ / Month`,
                basePrice: Number(dbPlan.base_price_monthly) || 0,
                isFree: Number(dbPlan.base_price_monthly) === 0,
              };
            }
            // If plan not found in DB, throw error
            throw new Error(`Plan "${plan.name}" not configured in database`);
          });

          setEnrichedPlans(enriched);
          setNetworkError(false); // Success - no error

        } catch (error) {
          console.error("Error fetching payment plans:", error);
          // ✅ DON'T set static plans - set error state instead
          setNetworkError(true); // You need to add this state
          setErrorMessage(error.message || 'Failed to load plan prices');
          setEnrichedPlans([]); // Clear any existing plans

        } finally {
          setIsLoadingPlans(false);
        }
      };
      fetchPrice();

    } else {
      Swal.fire({
        icon: "error",
        title: "Login Required",
        text: "Please login to process payment.",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked "Login" - redirect to login page
          window.location.href = `https://nktechhub.com/login`;
        } else if (result.isDenied || result.dismiss === Swal.DismissReason.cancel) {
          // User clicked "Cancel" or closed the dialog
          // Stay on current page
          console.log("User cancelled login");
          // Optionally, do something else like close a modal
        }
      });
    }
  }, [selectedSystemName]);




  const { width, height, isMobile, isTablet, isDesktop } = useWindowSize();
  const deviceType = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const navigate = useNavigate();

  // =====================================================
  // DRAG STATE
  // =====================================================
  const [pos, setPos] = useState({ x: 180, y: 70 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const startDrag = (e) => {
    if (isMobile) return;
    setDragging(true);
    setOffset({
      x: e.clientX - pos.x,
      y: e.clientY - pos.y,
    });
  };

  const onMove = (e) => {
    if (!dragging || isMobile) return;
    setPos({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y,
    });
  };

  const stopDrag = () => setDragging(false);

  const ensureSwalOnTop = () => {
    setTimeout(() => {
      const swalContainer = document.querySelector('.swal2-container');
      if (swalContainer) {
        swalContainer.style.zIndex = '9999999999';
      }
    }, 10);
  };

  // =====================================================
  // LOGIN ALERT
  // =====================================================
  const loginAlert = () => {
    setIsAlertOpen(true);
    setLoadingPaymentButton(true);

    // if (deviceType === "Mobile") {
    //   Swal.fire({
    //     title: "Mobile Access Detected",
    //     text: "You cannot login on a mobile device.",
    //     icon: "info",
    //     confirmButtonText: "OK"
    //   });
    //   ensureSwalOnTop();
    //   return;
    // } else if (deviceType === "Tablet") {
    //   Swal.fire({
    //     title: "Tablet Access Detected",
    //     text: "You cannot login on a tablet device.",
    //     icon: "info",
    //     confirmButtonText: "OK"
    //   });
    //   ensureSwalOnTop();
    //   return;
    // }

    if (selectedSystemName.includes("Offshore")) {
      setLoadingPaymentButton(false);
      Swal.fire({
        title: "Access Restricted",
        text: "This simulator is in testing stage. Please enter the access password.",
        icon: "info",
        input: "password",
        inputPlaceholder: "Enter password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Access Simulator",
        cancelButtonText: "Cancel",
        preConfirm: (password) => {
          if (!password) {
            Swal.showValidationMessage("Password is required");
            return false;
          }
          return password;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const enteredPassword = result.value;
          const correctPassword = "testdcs123";

          if (enteredPassword === correctPassword) {
            Swal.fire({
              icon: "success",
              title: "Access Granted",
              text: "Redirecting to Offshore DCS Simulator...",
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              navigate("/WellComp", { state: { fromLogin: true } });
              setIsAlertOpen(false);
            });
            ensureSwalOnTop();
          } else {
            Swal.fire({
              icon: "error",
              title: "Wrong Password",
              text: "Incorrect password. Please contact your instructor for access.",
              confirmButtonText: "Try Again"
            }).then(() => {
              loginAlert();
            });
            ensureSwalOnTop();
          }
        }
      });
    } else if (selectedSystemName.includes("Refinery")) {
      setLoadingPaymentButton(false);

      tokenRedirect();
      return;

      Swal.fire({
        title: "Access Restricted",
        text: "This simulator is in testing stage. Please enter the access password.",
        icon: "info",
        input: "password",
        inputPlaceholder: "Enter password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Access Simulator",
        cancelButtonText: "Cancel",
        preConfirm: (password) => {
          if (!password) {
            Swal.showValidationMessage("Password is required");
            return false;
          }
          return password;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const enteredPassword = result.value;
          const correctPassword = "testdcs123";

          if (enteredPassword === correctPassword) {
            Swal.fire({
              icon: "success",
              title: "Access Granted",
              text: "Redirecting to Refinery Simulator...",
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              
              //createSessionAndRedirect();
              
              //window.location.href = `https://refinery.nktechhub.com/?session=${sessionId}`;
            });
            ensureSwalOnTop();
          } else {
            Swal.fire({
              icon: "error",
              title: "Wrong Password",
              text: "Incorrect password. Please contact your instructor for access.",
              confirmButtonText: "Try Again"
            }).then(() => {
              loginAlert();
            });
            ensureSwalOnTop();
          }
        }
      });
    }
    ensureSwalOnTop();
  };

  // =====================================================
  // HANDLE PLAN SELECTION
  // =====================================================
  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setShowPaymentOptions(true);
    setSelectedBillingCycle("monthly");
    setCouponApplied(false);
    setDiscountPercentage(0);
    setCouponCode("");
  };

  // =====================================================
  // CALCULATE PRICE - FIXED
  // =====================================================
  const calculatePrice = (basePrice, cycle) => {
    // Ensure basePrice is a number
    const priceNum = Number(basePrice) || 0;

    let price = 0;
    let period = "";

    switch (cycle) {
      case "weekly":
        price = priceNum * 0.3;
        period = "week";
        break;
      case "monthly":
        price = priceNum;
        period = "month";
        break;
      case "yearly":
        price = priceNum * 10;
        period = "year";
        break;
      default:
        price = priceNum;
        period = "month";
    }

    if (couponApplied) {
      price = price * (1 - discountPercentage / 100);
    }

    return { price: price.toFixed(2), period };
  };

  // =====================================================
  // HANDLE COUPON APPLICATION
  // =====================================================
  const handleApplyCoupon = () => {
    const validCoupons = {
      "SAVE10": 10,
      "SAVE20": 20,
      "SAVE50": 50,
      "TRAINING2024": 15,
      "DCS2024": 25
    };

    const coupon = couponCode.toUpperCase().trim();

    if (validCoupons[coupon]) {
      setDiscountPercentage(validCoupons[coupon]);
      setCouponApplied(true);
      Swal.fire({
        icon: "success",
        title: "Coupon Applied!",
        text: `You saved ${validCoupons[coupon]}% on your subscription!`,
        timer: 2000,
        showConfirmButton: false
      });
      ensureSwalOnTop();
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Coupon",
        text: "Please enter a valid coupon code.",
        confirmButtonText: "OK"
      });
      ensureSwalOnTop();
    }
  };

  // =====================================================
  // PROCESS PAYMENT
  // =====================================================
  const processPayment = async () => {


    if (!userId) {
      Swal.fire({
        icon: "error",
        title: "Login Required",
        text: "Please login to process payment.",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked "Login" - redirect to login page
          window.location.href = `https://nktechhub.com/login`;
        } else if (result.isDenied || result.dismiss === Swal.DismissReason.cancel) {
          // User clicked "Cancel" or closed the dialog
          // Stay on current page
          return;
        }
      });

      // Ensure Swal is on top (your existing function)
      ensureSwalOnTop();
      return;
    }


    setIsLoading(true);

    // Extract numeric price from the price string (e.g., "20$ / Month" -> 20)
    const priceString = selectedPlan.price || "0";
    const numericPrice = parseFloat(priceString.replace(/[^0-9.]/g, ''));
    const basePrice = numericPrice || selectedPlan.basePrice || 0;

    const { price, period } = calculatePrice(basePrice, selectedBillingCycle);

    const paymentData = {
      plan: selectedPlan.name,
      system: selectedSystemName,
      billingCycle: selectedBillingCycle,
      amount: price,
      period: period,
      couponApplied: couponApplied,
      discount: discountPercentage,
      userId: userId,
      userEmail: userData.email,
      timestamp: new Date().toISOString()
    };


    // Goto paystack
    try {

      const res = await fetch(`https://api.nktechhub.com/api/dcs/create-payment-intent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': `Bearer ${import.meta.env.VITE_PAYSTACK_API_KEY}`
        },
        body: JSON.stringify(paymentData)
      });
      if (!res.ok) {
        throw new Error('Failed to start payment intent');
      }

      const data = await res.json();

      if (data.message) {
        Swal.fire({
          icon: "success",
          title: data.message,
        })
        ensureSwalOnTop();
        setIsLoading(false);
        return;
      }

      window.location.assign(data.authorizationUrl);
    } catch {
      setIsLoading(false);
    }

    // setTimeout(() => {
    //   setIsLoading(false);

    //   Swal.fire({
    //     icon: "success",
    //     title: "Payment Successful!",
    //     html: `
    //       <div style="text-align: left;">
    //         <p><strong>Plan:</strong> ${selectedPlan.name}</p>
    //         <p><strong>Billing Cycle:</strong> ${selectedBillingCycle.charAt(0).toUpperCase() + selectedBillingCycle.slice(1)}</p>
    //         <p><strong>Amount:</strong> $${price} / ${period}</p>
    //         ${couponApplied ? `<p><strong>Discount:</strong> ${discountPercentage}%</p>` : ''}
    //       </div>
    //     `,
    //     confirmButtonText: "Access Simulator",
    //     showCancelButton: true,
    //     cancelButtonText: "View Invoice"
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       localStorage.setItem("selectedPlan", selectedPlan.name);
    //       localStorage.setItem("selectedSystem", selectedSystemName);

    //       if (selectedSystemName.includes("Offshore")) {
    //         navigate("/WellComp", { state: { fromLogin: true } });
    //       } else if (selectedSystemName.includes("Refinery")) {
    //         window.location.href = `https://refinery.nktechhub.com/?user=${userId}`;
    //       }
    //       onClose();
    //     } else {
    //       showInvoice(paymentData);
    //     }
    //   });
    //   ensureSwalOnTop();
    // }, 2000);
  };

  // =====================================================
  // SHOW INVOICE
  // =====================================================
  const showInvoice = (paymentData) => {
    Swal.fire({
      title: "Invoice",
      html: `
        <div style="text-align: left; font-size: 14px;">
          <p><strong>Invoice #:</strong> INV-${Date.now()}</p>
          <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
          <p><strong>Plan:</strong> ${paymentData.plan}</p>
          <p><strong>System:</strong> ${paymentData.system}</p>
          <p><strong>Billing Cycle:</strong> ${paymentData.billingCycle}</p>
          <p><strong>Amount:</strong> $${paymentData.amount} / ${paymentData.period}</p>
          ${paymentData.couponApplied ? `<p><strong>Discount:</strong> ${paymentData.discount}%</p>` : ''}
          <hr style="margin: 10px 0; border-color: #444;">
          <p><strong>Total:</strong> $${paymentData.amount}</p>
        </div>
      `,
      confirmButtonText: "Download Invoice",
      showCancelButton: true,
      cancelButtonText: "Close"
    }).then((result) => {
      if (result.isConfirmed) {
        const invoiceText = `Invoice #: INV-${Date.now()}\nDate: ${new Date().toLocaleDateString()}\nPlan: ${paymentData.plan}\nSystem: ${paymentData.system}\nBilling Cycle: ${paymentData.billingCycle}\nAmount: $${paymentData.amount} / ${paymentData.period}\nTotal: $${paymentData.amount}`;
        const blob = new Blob([invoiceText], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Invoice-${Date.now()}.txt`;
        a.click();
        URL.revokeObjectURL(url);
      }
    });
    ensureSwalOnTop();
  };

  // =====================================================
  // GET PLAN BASE PRICE
  // =====================================================
  const getPlanBasePrice = (planName) => {
    if (Array.isArray(paymentPlans) && paymentPlans.length > 0) {
      const dbPlan = paymentPlans.find(p => p.plan_name === planName);
      if (dbPlan && dbPlan.base_price_monthly !== undefined) {
        return Number(dbPlan.base_price_monthly) || 0;
      }
    }

    const priceMap = {
      "Operator Training Package": 20,
      "Process Engineer Suite": 30,
      "Classroom": 50,
      "Enterprise / Plant Engineer": 80
    };
    return priceMap[planName] || 20;
  };

  // =====================================================
  // BACK TO PLANS
  // =====================================================
  const handleBackToPlans = () => {
    setShowPaymentOptions(false);
    setSelectedPlan(null);
    setCouponApplied(false);
    setDiscountPercentage(0);
    setCouponCode("");
  };

  // =====================================================
  // MASTER PAYMENT PLAN DATA
  // =====================================================
  const allPlans = {
    "250,000 BPD Offshore Production DCS": [
      {
        name: "Visitor Level (Free)",
        color: "#00d4ff",
        duration: "20 Minutes Session",
        price: "FREE",
        isFree: true,
        features: [
          { label: "NK-1 Wellhead Access", value: true },
          { label: "Single Screen Operation", value: true },
          { label: "Control Valves / Chokes", value: true },
          { label: "PID Auto / Manual", value: true },
          { label: "Trend Viewing", value: true },
          { label: "Export Charts", value: true },
          { label: "8 Screen Navigation", value: false },
          { label: "Full Plant Operations", value: false },
        ],
      },
      {
        name: "Operator Training Package",
        color: "#00ff88",
        duration: "Unlimited Access",
        price: "20$ / Month",
        basePrice: 20,
        features: [
          { label: "8 Process Screens", value: true },
          { label: "Separator Operations", value: true },
          { label: "Pigging Operations", value: true },
          { label: "Level / Pressure Control", value: true },
          { label: "Test Separator Use", value: true },
          { label: "Alarm Handling", value: true },
          { label: "Reservoir Editing", value: false },
          { label: "Full Engineering Override", value: false },
        ],
      },
      {
        name: "Process Engineer Suite",
        color: "#ffaa00",
        duration: "Professional Access",
        price: "30$ / Month",
        basePrice: 30,
        features: [
          { label: "All Screens Except Well Composition", value: true },
          { label: "Compressor Systems", value: true },
          { label: "Heat Exchanger Review", value: true },
          { label: "Separator Tuning", value: true },
          { label: "Advanced Trends", value: true },
          { label: "Engineering Reports", value: true },
          { label: "Well Composition Edit", value: false },
          { label: "Reservoir Override", value: false },
        ],
      },
      {
        name: "Classroom",
        color: "#ff3b3b",
        duration: "Full Digital Twin",
        price: "Custom Pricing",
        basePrice: 50,
        features: [
          { label: "All Plant + Subsea Systems", value: true },
          { label: "Reservoir Pressure Edit", value: true },
          { label: "Crude Composition Edit", value: true },
          { label: "Water / Gas / Impurity Edit", value: true },
          { label: "Shutdown Logic Access", value: true },
          { label: "Full Engineering Override", value: true },
          { label: "Unlimited Scenario Simulation", value: true },
          { label: "Corporate Deployment", value: true },
        ],
      },
    ],
    "30,000 BPD Modular Refinery": [
      {
        name: "Visitor Level (Free)",
        color: "#00d4ff",
        duration: "15 Minutes Session",
        price: "FREE",
        isFree: true,
        features: [
          { label: "Crude Heater Screen", value: true },
          { label: "Column Overview", value: true },
          { label: "Manual Valve Use", value: true },
          { label: "Trend View", value: true },
          { label: "Product Routing", value: false },
          { label: "Tank Farm Access", value: false },
          { label: "Alarm Response", value: false },
          { label: "Engineering Mode", value: false },
        ],
      },
      {
        name: "Operator Training Package",
        color: "#00ff88",
        duration: "Unlimited Access",
        price: "25$ / Month",
        basePrice: 25,
        features: [
          { label: "Distillation Operations", value: true },
          { label: "Pump Operations", value: true },
          { label: "Tank Farm Navigation", value: true },
          { label: "Product Transfer", value: true },
          { label: "Alarm System", value: true },
          { label: "Trend Reports", value: true },
          { label: "Yield Optimization", value: false },
          { label: "Engineering Design", value: false },
        ],
      },
      {
        name: "Process Engineer Suite",
        color: "#ffaa00",
        duration: "Engineer Access",
        price: "35$ / Month",
        basePrice: 35,
        features: [
          { label: "Yield Monitoring", value: true },
          { label: "Energy Efficiency", value: true },
          { label: "Column Balance", value: true },
          { label: "Heat Duty Review", value: true },
          { label: "Reports Export", value: true },
          { label: "Advanced Trends", value: true },
          { label: "Crude Assay Edit", value: false },
          { label: "Full Plant Override", value: false },
        ],
      },
      {
        name: "Classroom",
        color: "#ff3b3b",
        duration: "Full Refinery Twin",
        price: "Custom Pricing",
        basePrice: 60,
        features: [
          { label: "Crude Assay Editing", value: true },
          { label: "Feed Rate Change", value: true },
          { label: "Product Slate Simulation", value: true },
          { label: "Full Plant Override", value: true },
          { label: "Corporate Multi User", value: true },
          { label: "Shutdown Logic", value: true },
          { label: "Scenario Training", value: true },
          { label: "Unlimited Access", value: true },
        ],
      },
    ],
    "1000 BPD Modular Refinery": [],
    "10,000 BPD Hydroskimming Refinery": [],
    "5,000 BPD Modular Refinery": [],
    "100,000 BPD Conventional Refinery": [],
    "500 MMSCFD Gas Plant": [],
    "2000 MMSCFD Gas Processing Plant": [],
    "5000 MMSCFD LNG Feed Gas Plant": [],
    "100,000 MMSCFD LNG Feed Gas Plant": [],
    "Onshore Production Facility (OPF)": [],
    "Gathering Station System": [],
    "Small Scale Methanol Plant": [],
    "Industrial Methanol Complex": [],
    "Bio-Ethanol Plant": [],
    "Industrial Ethanol Production Unit": [],
  };

  // =====================================================
  // FALLBACK
  // =====================================================
  const defaultPlans = allPlans["250,000 BPD Offshore Production DCS"];

  const plansToRender = enrichedPlans //.length > 0 ? enrichedPlans : (allPlans[selectedSystemName] || defaultPlans);

  // =====================================================
  // FEATURE ROW
  // =====================================================
  const Row = ({ label, value }) => (
    <div className="plan-row">
      <span>{label}</span>
      <span className={value ? "tick" : "cross"}>
        {value ? "✔" : "✖"}
      </span>
    </div>
  );

  // =====================================================
  // GET RESPONSIVE STYLES
  // =====================================================
  const getWindowStyles = () => {
    if (isMobile) {
      return {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95%',
        maxWidth: '400px',
        height: 'auto',
        maxHeight: '90vh',
        overflow: 'auto',
        margin: 0,
        borderRadius: '16px',
        zIndex: 9999,
      };
    } else if (isTablet) {
      return {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '700px',
        height: 'auto',
        maxHeight: '85vh',
        overflow: 'auto',
        margin: 0,
        borderRadius: '14px',
        zIndex: 9999,
      };
    }
    return {
      position: 'absolute',
      left: pos.x,
      top: pos.y,
      width: '1050px',
      maxWidth: '90vw',
      height: showPaymentOptions ? '650px' : '590px',
      maxHeight: '85vh',
      overflow: 'auto',
      borderRadius: '12px',
      zIndex: 9999,
    };
  };

  // =====================================================
  // RENDER PAYMENT OPTIONS
  // =====================================================
  const renderPaymentOptions = () => {
    // Ensure basePrice is a number
    const basePrice = selectedPlan ? Number(selectedPlan.basePrice) || getPlanBasePrice(selectedPlan.name) || 0 : 0;
    const weeklyPrice = calculatePrice(basePrice, "weekly");
    const monthlyPrice = calculatePrice(basePrice, "monthly");
    const yearlyPrice = calculatePrice(basePrice, "yearly");

    return (
      <div style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <button
              onClick={handleBackToPlans}
              style={{
                background: 'transparent',
                border: '1px solid #00d4ff',
                color: '#00d4ff',
                padding: '8px 16px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              ← Back to Plans
            </button>
          </div>
          <h3 style={{ color: '#fff', margin: 0 }}>{selectedPlan?.name}</h3>
          <div style={{ width: '100px' }}></div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '15px', flex: 1 }}>
          {/* Weekly Option */}
          <div style={{
            border: selectedBillingCycle === 'weekly' ? '2px solid #00d4ff' : '1px solid #333',
            borderRadius: '12px',
            padding: '20px',
            background: selectedBillingCycle === 'weekly' ? 'rgba(0, 212, 255, 0.1)' : 'rgba(255,255,255,0.03)',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
            onClick={() => setSelectedBillingCycle('weekly')}
          >
            <h4 style={{ color: '#00d4ff', margin: '0 0 10px 0' }}>Weekly</h4>
            <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#fff' }}>
              ${weeklyPrice.price}
              <span style={{ fontSize: '14px', color: '#8899aa', fontWeight: 'normal' }}> / {weeklyPrice.period}</span>
            </div>
            <div style={{ fontSize: '12px', color: '#8899aa', marginTop: '8px' }}>
              {couponApplied ? `Original: $${(basePrice * 0.3).toFixed(2)}` : 'Billed weekly'}
            </div>
          </div>

          {/* Monthly Option (Recommended) */}
          <div style={{
            border: selectedBillingCycle === 'monthly' ? '2px solid #00ff88' : '1px solid #333',
            borderRadius: '12px',
            padding: '20px',
            background: selectedBillingCycle === 'monthly' ? 'rgba(0, 255, 136, 0.1)' : 'rgba(255,255,255,0.03)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}
            onClick={() => setSelectedBillingCycle('monthly')}
          >
            <div style={{
              position: 'absolute',
              top: '-10px',
              right: '10px',
              background: '#00ff88',
              color: '#001018',
              padding: '2px 12px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              BEST VALUE
            </div>
            <h4 style={{ color: '#00ff88', margin: '0 0 10px 0' }}>Monthly</h4>
            <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#fff' }}>
              ${monthlyPrice.price}
              <span style={{ fontSize: '14px', color: '#8899aa', fontWeight: 'normal' }}> / {monthlyPrice.period}</span>
            </div>
            <div style={{ fontSize: '12px', color: '#8899aa', marginTop: '8px' }}>
              {couponApplied ? `Original: $${basePrice.toFixed(2)}` : 'Billed monthly'}
            </div>
          </div>

          {/* Yearly Option */}
          <div style={{
            border: selectedBillingCycle === 'yearly' ? '2px solid #ffaa00' : '1px solid #333',
            borderRadius: '12px',
            padding: '20px',
            background: selectedBillingCycle === 'yearly' ? 'rgba(255, 170, 0, 0.1)' : 'rgba(255,255,255,0.03)',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
            onClick={() => setSelectedBillingCycle('yearly')}
          >
            <h4 style={{ color: '#ffaa00', margin: '0 0 10px 0' }}>Yearly</h4>
            <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#fff' }}>
              ${yearlyPrice.price}
              <span style={{ fontSize: '14px', color: '#8899aa', fontWeight: 'normal' }}> / {yearlyPrice.period}</span>
            </div>
            <div style={{ fontSize: '12px', color: '#8899aa', marginTop: '8px' }}>
              Save 2 months free!
              {couponApplied && ` (${discountPercentage}% off)`}
            </div>
          </div>
        </div>

        {/* Coupon Section */}
        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: 'rgba(255,255,255,0.03)',
          borderRadius: '10px',
          border: '1px solid #333'
        }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
            <input
              type="text"
              placeholder="Enter coupon code"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              style={{
                flex: 1,
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #444',
                background: 'rgba(255,255,255,0.05)',
                color: '#fff',
                fontSize: '14px',
                minWidth: '150px'
              }}
              disabled={couponApplied}
            />
            <button
              onClick={handleApplyCoupon}
              disabled={couponApplied || !couponCode.trim()}
              style={{
                padding: '10px 24px',
                borderRadius: '8px',
                border: 'none',
                background: couponApplied ? '#444' : '#00d4ff',
                color: couponApplied ? '#666' : '#001018',
                cursor: couponApplied || !couponCode.trim() ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              {couponApplied ? `✓ ${discountPercentage}% OFF` : 'Apply Coupon'}
            </button>
            {couponApplied && (
              <button
                onClick={() => {
                  setCouponApplied(false);
                  setDiscountPercentage(0);
                  setCouponCode("");
                }}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: '1px solid #ff3b3b',
                  background: 'transparent',
                  color: '#ff3b3b',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Remove
              </button>
            )}
          </div>
          <div style={{ fontSize: '12px', color: '#8899aa', marginTop: '8px' }}>
            
          </div>
        </div>

        {/* Payment Button */}
        <button
          onClick={processPayment}
          disabled={isLoading}
          style={{
            marginTop: '20px',
            padding: '14px',
            borderRadius: '10px',
            border: 'none',
            background: 'linear-gradient(135deg, #00d4ff, #0088ff)',
            color: '#fff',
            fontSize: '18px',
            fontWeight: 'bold',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1,
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 20px rgba(0, 212, 255, 0.3)'
          }}
        >
          {isLoading ? 'Processing...' : `Pay Now - $${calculatePrice(basePrice, selectedBillingCycle).price} / ${calculatePrice(basePrice, selectedBillingCycle).period}`}
        </button>

        <div style={{ fontSize: '11px', color: '#667788', textAlign: 'center', marginTop: '10px' }}>
          Secure payment. Cancel anytime. No hidden fees.
        </div>
      </div>
    );
  };




  if (networkError) {
    return ReactDOM.createPortal(
      <div className="payment-overlay">
        <div className="payment-window" style={getWindowStyles()}>
          <div style={{
            padding: '40px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            minHeight: '300px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📡</div>
            <h3 style={{ color: '#ff6b6b', marginBottom: '12px' }}>Network Connection Lost</h3>
            <p style={{ color: '#8899aa', marginBottom: '8px' }}>
              Unable to fetch plan details. Please check your internet connection.
            </p>
            {/* {errorMessage && (
            <p style={{ color: '#667788', fontSize: '14px', marginBottom: '20px' }}>
              Error: {errorMessage}
            </p>
          )} */}
            <button
              onClick={() => {
                setNetworkError(false);
                setIsLoadingPlans(true);
                // Re-fetch
                const fetchPrice = async () => {
                  try {
                    setIsLoadingPlans(true);
                    setNetworkError(false);

                    const response = await fetch(`http://api.nktechhub.com/api/dcs/payment_plans`);

                    if (!response.ok) {
                      throw new Error(`Failed to fetch: ${response.status}`);
                    }

                    const data = await response.json();
                    const dbPlans = data.plans?.rows || data.plans || data || [];

                    if (!dbPlans || dbPlans.length === 0) {
                      throw new Error('No plans found in database');
                    }

                    setPaymentPlans(dbPlans);

                    const staticPlans = allPlans[selectedSystemName] || defaultPlans;
                    const enriched = staticPlans.map(plan => {
                      const dbPlan = dbPlans.find(p => p.plan_name === plan.name);
                      if (dbPlan) {
                        return {
                          ...plan,
                          price: Number(dbPlan.base_price_monthly) === 0 ? "FREE" : `${dbPlan.base_price_monthly}$ / Month`,
                          basePrice: Number(dbPlan.base_price_monthly) || 0,
                          isFree: Number(dbPlan.base_price_monthly) === 0,
                        };
                      }
                      throw new Error(`Plan "${plan.name}" not configured`);
                    });

                    setEnrichedPlans(enriched);
                    setNetworkError(false);

                  } catch (error) {
                    console.error("Error fetching payment plans:", error);
                    setNetworkError(true);
                    setErrorMessage(error.message || 'Failed to load plan prices');
                    setEnrichedPlans([]);
                  } finally {
                    setIsLoadingPlans(false);
                  }
                };
                fetchPrice();
              }}
              style={{
                padding: '12px 32px',
                background: '#00d4ff',
                color: '#001018',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px',
                transition: 'all 0.3s ease'
              }}
            >
              🔄 Retry Connection
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  }



  // =====================================================
  // LOADING STATE
  // =====================================================
  if (isLoadingPlans) {
    return ReactDOM.createPortal(
      <div className="payment-overlay">
        <div className="payment-window" style={getWindowStyles()}>
          <div style={{ padding: '40px', textAlign: 'center' }}>
            <div style={{ color: '#00d4ff', fontSize: '24px', marginBottom: '20px' }}>Loading plans...</div>
            <div style={{ color: '#8899aa' }}>Please wait while we fetch pricing information</div>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  // =====================================================
  // UI
  // =====================================================
  const modal = (
    <div
      className="payment-overlay"
      onMouseMove={onMove}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
    >
      <div
        className="payment-window"
        style={getWindowStyles()}
      >
        {/* HEADER */}
        <div
          className="payment-header"
          onMouseDown={startDrag}
          style={{
            cursor: isMobile ? 'default' : 'grab',
            padding: isMobile ? '12px 16px' : '0 16px',
            minHeight: isMobile ? '50px' : '55px',
          }}
        >
          <h3 style={{
            fontSize: isMobile ? '13px' : '16px',
            margin: 0,
            wordBreak: 'break-word',
          }}>
            {showPaymentOptions ? 'Choose Your Plan' : `NK Tech DCS - ${selectedSystemName}`}
          </h3>
          <button
            onClick={onClose}
            style={{
              width: isMobile ? '36px' : '30px',
              height: isMobile ? '36px' : '30px',
              fontSize: isMobile ? '20px' : '18px',
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div
          className="plan-container"
          style={{
            display: showPaymentOptions ? 'block' : 'grid',
            gridTemplateColumns: showPaymentOptions ? 'none' : (isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)'),
            gap: isMobile ? '12px' : '14px',
            padding: isMobile ? '12px' : '14px',
            height: showPaymentOptions ? 'calc(100% - 55px)' : (isMobile ? 'auto' : 'calc(100% - 55px)'),
            maxHeight: isMobile ? 'calc(90vh - 60px)' : 'none',
            overflow: 'auto',
          }}
        >
          {showPaymentOptions ? (
            renderPaymentOptions()
          ) : (
            plansToRender.map((plan, i) => (
              <div
                key={i}
                className="plan-card"
                style={{
                  borderColor: plan.color,
                  minHeight: isMobile ? 'auto' : '460px',
                  padding: isMobile ? '14px' : '14px 12px',
                  borderRadius: '14px',
                  background: 'rgba(255,255,255,0.03)',
                  border: `1px solid ${plan.color}`,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.25s ease',
                }}
              >
                <div
                  className="plan-title"
                  style={{
                    color: plan.color,
                    fontSize: isMobile ? '16px' : '15px',
                    fontWeight: 700,
                    marginBottom: '6px',
                    lineHeight: 1.3,
                  }}
                >
                  {plan.name}
                </div>

                <div
                  className="plan-duration"
                  style={{
                    fontSize: isMobile ? '12px' : '12px',
                    color: '#b8c7d6',
                    marginBottom: '6px',
                  }}
                >
                  {plan.duration}
                </div>

                <div
                  className="plan-price"
                  style={{
                    fontSize: isMobile ? '20px' : '18px',
                    fontWeight: 800,
                    color: '#ffffff',
                    marginBottom: '10px',
                  }}
                >
                  {plan.price}
                </div>

                <div
                  className="plan-features"
                  style={{
                    marginTop: '10px',
                    fontSize: isMobile ? '12px' : '12px',
                    lineHeight: isMobile ? '2' : '2',
                    flex: '1',
                  }}
                >
                  {plan.features.map((f, idx) => (
                    <Row key={idx} label={f.label} value={f.value} />
                  ))}
                </div>

                <button
                  className="buy-btn"
                  style={{
                    background: plan.color,
                    color: '#001018',
                    border: 'none',
                    padding: isMobile ? '14px' : '11px',
                    borderRadius: '10px',
                    fontSize: isMobile ? '15px' : '13px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    marginTop: '12px',
                    transition: 'all 0.25s ease',
                    boxShadow: '0 0 10px rgba(0,255,255,0.15)',
                  }}
                  onClick={() => {
                    if (plan.isFree) {
                      loginAlert();
                      return;
                    } else if (plan.name === "Classroom") {
                      Swal.fire({
                        icon: "info",
                        title: "Coming Soon",
                        text: "Classroom access is coming soon. Stay tuned!",
                        confirmButtonText: "OK"
                      });
                      ensureSwalOnTop();
                      return;
                    }
                    handlePlanSelect(plan);
                  }}
                >
                  {  plan.isFree ? "Login" : plan.name === "Classroom" ? "Coming Soon" : "Buy Now"}
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

export default PaymentPlanWindow;